/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Equivalence_WhaleInputs */

const en_us2_equivalence_whale = /** @type {(inputs: Equivalence_WhaleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`the weight of a blue whale`);
	return /** @type {LocalizedString} */ (`the weight of ${i?.amount} blue whales`)
	
};

const pt_br2_equivalence_whale = /** @type {(inputs: Equivalence_WhaleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de uma baleia-azul`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} baleias-azuis`)
	
};

const es_419_equivalence_whale = /** @type {(inputs: Equivalence_WhaleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`el peso de una ballena azul`);
	return /** @type {LocalizedString} */ (`el peso de ${i?.amount} ballenas azules`)
	
};

const pt_pt2_equivalence_whale = /** @type {(inputs: Equivalence_WhaleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de uma baleia-azul`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} baleias-azuis`)
	
};

const fr_fr2_equivalence_whale = /** @type {(inputs: Equivalence_WhaleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`le poids d'une baleine bleue`);
	return /** @type {LocalizedString} */ (`le poids de ${i?.amount} baleines bleues`)
	
};

const de_de2_equivalence_whale = /** @type {(inputs: Equivalence_WhaleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`das Gewicht eines Blauwals`);
	return /** @type {LocalizedString} */ (`das Gewicht von ${i?.amount} Blauwalen`)
	
};

const it_it2_equivalence_whale = /** @type {(inputs: Equivalence_WhaleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`il peso di una balenottera azzurra`);
	return /** @type {LocalizedString} */ (`il peso di ${i?.amount} balenottere azzurre`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "the weight of a blue whale" |
* | * | "the weight of {amount} blue whales" |
*
* @param {Equivalence_WhaleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_whale = /** @type {((inputs: Equivalence_WhaleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_WhaleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_whale(inputs)
	if (locale === "es-419") return es_419_equivalence_whale(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_whale(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_whale(inputs)
	if (locale === "de-DE") return de_de2_equivalence_whale(inputs)
	if (locale === "it-IT") return it_it2_equivalence_whale(inputs)
	return en_us2_equivalence_whale(inputs)
});
export { equivalence_whale as "equivalence.whale" }